"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEntityListSortAttr = parseEntityListSortAttr;
exports.computeEntityListRows = computeEntityListRows;
exports.parseEntityListTypesAttr = parseEntityListTypesAttr;
/** Normalize Entity-List `sort=` attribute. */
function parseEntityListSortAttr(raw) {
    const sortRaw = String(raw ?? '')
        .trim()
        .toLowerCase();
    if (sortRaw === 'created-desc' || sortRaw === 'created_desc') {
        return 'created-desc';
    }
    if (sortRaw === 'created') {
        return 'created';
    }
    if (sortRaw === 'position') {
        return 'position';
    }
    return 'name';
}
function readEntityStringValue(entitiesService, entityId, name) {
    const raw = entitiesService.getEntityVariable(entityId, name)?.value;
    if (raw === undefined || raw === null) {
        return '';
    }
    return String(raw).trim();
}
function computeEntityListRows(entities, entityTypes, entitiesService, embed = {}) {
    const typeMap = new Map(entityTypes.map(t => [t.id, t]));
    // Adventure-edit resilience: hide instances whose type_id is no longer declared.
    let list = entities.filter(e => typeMap.has(e.typeId));
    if (embed.types && embed.types.length > 0) {
        const allowed = new Set(embed.types);
        list = list.filter(e => allowed.has(e.typeId));
    }
    if (embed.parentEntityId === null) {
        list = list.filter(e => !e.parentEntityId);
    }
    else if (embed.parentEntityId !== undefined) {
        const p = embed.parentEntityId.trim();
        list = list.filter(e => e.parentEntityId === p);
    }
    const filterVariable = typeof embed.filterVariable === 'string' ? embed.filterVariable.trim() : '';
    if (filterVariable) {
        const expected = embed.filterValue === undefined || embed.filterValue === null
            ? ''
            : String(embed.filterValue).trim();
        list = list.filter(e => readEntityStringValue(entitiesService, e.uuid, filterVariable) === expected);
    }
    const contentVariable = typeof embed.contentVariable === 'string' ? embed.contentVariable.trim() : '';
    const trailingContentVariable = typeof embed.trailingContentVariable === 'string'
        ? embed.trailingContentVariable.trim()
        : '';
    const rows = list.map(e => {
        const typeDef = typeMap.get(e.typeId);
        const row = {
            entityId: e.uuid,
            typeId: e.typeId,
            displayName: entitiesService.getDisplayName(e.uuid, typeDef?.displayName),
            parentEntityId: e.parentEntityId,
            startSceneId: typeDef?.startSceneId ?? ''
        };
        if (contentVariable) {
            const asStr = readEntityStringValue(entitiesService, e.uuid, contentVariable);
            if (asStr) {
                row.content = asStr;
            }
        }
        if (trailingContentVariable) {
            const trailing = readEntityStringValue(entitiesService, e.uuid, trailingContentVariable);
            if (trailing) {
                row.trailing = trailing;
            }
        }
        return row;
    });
    const sort = embed.sort ?? 'name';
    if (sort === 'created' || sort === 'created-desc') {
        const created = new Map(entities.map(e => [e.uuid, e.createdAtMs]));
        rows.sort((a, b) => (created.get(a.entityId) ?? 0) - (created.get(b.entityId) ?? 0));
        if (sort === 'created-desc') {
            rows.reverse();
        }
    }
    else if (sort === 'position') {
        rows.sort((a, b) => {
            const posA = Number.parseInt(readEntityStringValue(entitiesService, a.entityId, 'position') || '0', 10);
            const posB = Number.parseInt(readEntityStringValue(entitiesService, b.entityId, 'position') || '0', 10);
            const safeA = Number.isFinite(posA) ? posA : 0;
            const safeB = Number.isFinite(posB) ? posB : 0;
            if (safeA !== safeB) {
                return safeA - safeB;
            }
            return a.entityId.localeCompare(b.entityId);
        });
    }
    else {
        rows.sort((a, b) => a.displayName.localeCompare(b.displayName, undefined, { sensitivity: 'base' }));
    }
    return rows;
}
/** Parse comma-separated type ids from Entity-List `types=` attribute. */
function parseEntityListTypesAttr(raw) {
    if (raw === undefined || raw === null) {
        return undefined;
    }
    const parts = String(raw)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
    return parts.length > 0 ? parts : undefined;
}
//# sourceMappingURL=computeEntityListRows.js.map